import { Injectable } from "@angular/core";

import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { addTicket, addTicketComment, addTicketCommentFailure, addTicketCommentSuccess, addTicketFailure, addTicketSuccess, fetchSingleTicketData, fetchSingleTicketDataFailure, fetchSingleTicketDataSuccess, fetchTicketCommentsData, fetchTicketCommentsDataFailure, fetchTicketCommentsDataSuccess, fetchTicketListData, fetchTicketListFailure, fetchTicketListSuccess, fetchTicketsCategories, fetchTicketsCategoriesFailure, fetchTicketsCategoriesSuccess, fetchTicketsStatsData, fetchTicketsStatsDataFailure, fetchTicketsStatsDataSuccess, updateTicket, updateTicketFailure, updateTicketSuccess } from "./ticket_action";
import { TicketsService } from "../../core/services/tickets.service";
import { ToastifyService } from "../../shared/toastify-service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { GlobalComponent } from "../../global-component";


@Injectable()
export class TicketEffects {
  fetchTicketList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchTicketListData),
      mergeMap(({ limit, skip }) =>
        this.restApiService.getTicketData(limit, skip).pipe(
          map((data) => {
            return fetchTicketListSuccess({ tickets: data })
          }),
          catchError((error) =>
            of(fetchTicketListFailure({ error }))
          )
        )
      ),
    ),
  );

  addTicketData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addTicket),
      mergeMap(({ postdata }) =>
        this.restApiService.postTicketData(postdata).pipe(
          map((responseData) => addTicketSuccess({ newData: responseData })),
          catchError((error) => of(addTicketFailure({ error })))
        )
      )
    )
  )

  addTicketDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addTicketFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  addTicketCommentData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addTicketComment),
      mergeMap(({ postdata }) =>
        this.restApiService.postTicketCommentData(postdata).pipe(
          map((responseData) => addTicketCommentSuccess({ newData: responseData.data })),
          catchError((error) => of(addTicketCommentFailure({ error })))
        )
      )
    )
  )

  //SHOW ERROR MESSAGE OF API
  addTicketCommentDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addTicketCommentFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //FETCH STATS DATA
  fetchTicketsStatsData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTicketsStatsData),
        mergeMap(() =>
          this.restApiService.fetchTicketsStats().pipe(
            map((data) => {
              return fetchTicketsStatsDataSuccess({ stats: data });
            }),
            catchError((error) => of(fetchTicketsStatsDataFailure({ error })))
          )
        ),
      ),
  );

  //SHOW ERROR MESSAGE OF STATS API
  fetchTicketsStatsDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTicketsStatsDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH TICKET CATEGORIES FROM FIREBASE
  fetchTicketsCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchTicketsCategories),
      mergeMap(() =>
        this.afs.collection(GlobalComponent.firebaseticketsystemcollname).doc(GlobalComponent.firebaseticketsystemcollid)
          .valueChanges().pipe(
            map((docs: any) => {
              console.log(":docs", docs)
              return fetchTicketsCategoriesSuccess(docs);
            }),
            catchError((error) =>
              of(fetchTicketsCategoriesFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchTicketsCategoriesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchTicketsCategoriesFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  udpateTicketData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateTicket),
      mergeMap(({ postdata, recordid }) =>
        this.restApiService.updateTicketData(postdata, recordid).pipe(
          map((responseData) => updateTicketSuccess({ newData: responseData })),
          catchError((error) => of(updateTicketFailure({ error })))
        )
      )
    )
  );

  updateTicketSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateTicketSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Ticket updated successfully.");
        })
      ),
    { dispatch: false }
  );

  updateTicketFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateTicketFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  fetchSingleTicketData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSingleTicketData),
      mergeMap(({ id }) =>
        this.restApiService.getSingleTicketData(id).pipe(
          map((data) => {
            return fetchSingleTicketDataSuccess({ ticket: data })
          }),
          catchError((error) =>
            of(fetchSingleTicketDataFailure({ error }))
          )
        )
      ),
    ),
  );

  //TICKET COMMENTS
  fetchTicketCommentsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchTicketCommentsData),
      mergeMap(({ ticketsystemguid }) =>
        this.restApiService.getTicketComments(ticketsystemguid).pipe(
          map((data) => {
            return fetchTicketCommentsDataSuccess({ ticketcomments: data })
          }),
          catchError((error) =>
            of(fetchTicketCommentsDataFailure({ error }))
          )
        )
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private restApiService: TicketsService,
    private toastifyService: ToastifyService,
    private afs: AngularFirestore,
  ) { }
}